import * as fromUserInformationActions from '../actions';
import { User } from '../../../user-management/users/user';

export interface UserInformationState {
  entity: User;
  loaded: boolean;
  loading: boolean;
}

export const userInformationInitialState: UserInformationState = {
  entity: {} as User,
  loaded: false,
  loading: false
};

export function reducer(
  state: UserInformationState = userInformationInitialState,
  action: fromUserInformationActions.UserInformationActions
): UserInformationState {
  switch (action.type) {
    case fromUserInformationActions.LOAD_USER_INFORMATION: {
      return {
        ...state,
        loaded: false,
        loading: true
      };
    }

    case fromUserInformationActions.LOAD_USER_INFORMATION_SUCCESS: {
      const entity: User = action.payload;
      return {
        ...state,
        entity,
        loaded: true,
        loading: false
      };
    }

    case fromUserInformationActions.LOAD_USER_INFORMATION_FAIL: {
      console.error('failed', action.payload);
      return {
        ...state
      };
    }
  }

  return state;
}

export const getUserInformationEntity: any = (
  state: UserInformationState
): User => state.entity;
export const getUserInformationLoaded: any = (
  state: UserInformationState
): boolean => state.loaded;
export const getUserInformationLoading: any = (
  state: UserInformationState
): boolean => state.loading;
